import { QSelect as e } from "quasar";
import { computed as t, createBlock as n, defineComponent as r, mergeModels as i, mergeProps as a, openBlock as o, ref as s, unref as c, useModel as l, watch as u } from "vue";
import { SEARCH_DEBOUNCE as d, registerEntityEndpoint as f } from "@editor/ui-utils";
import { queryOptions as p, useQuery as m, useQueryClient as h } from "@tanstack/vue-query";
import { useI18n as g } from "vue-i18n";
//#region src/services/job.service.ts
var _ = "Jobs", v = f(_), { listEntities: y, getEntity: b } = v, x = async (e, t) => y({ params: {
	...t,
	search: e
} }), S = async (e) => b(e), C = 600 * 1e3, w = (e) => p({
	queryKey: ["bf-jobs", e],
	queryFn: () => x(e),
	staleTime: C
}), T = (e) => p({
	queryKey: ["bf-job", e],
	queryFn: () => S(e),
	staleTime: C
}), E = /* @__PURE__ */ r({
	__name: "bf-job.selector",
	props: /* @__PURE__ */ i({ multiple: { type: Boolean } }, {
		modelValue: {},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(r) {
		let i = l(r, "modelValue", { set: (e) => e || void 0 }), { t: f } = g(), p = h(), { data: _, isFetching: v } = m(w(void 0)), y = s(null), b = s([]), x = t(() => i.value ? Array.isArray(i.value) ? i.value : [i.value] : []), S = t(() => {
			let e = y.value ?? _.value?.list ?? [], t = b.value.filter((t) => !e.some((e) => e._id === t._id));
			return [...e, ...t];
		});
		u([x, () => _.value?.list], async ([e, t]) => {
			if (!e.length || !t) return;
			let n = e.filter((e) => !t.some((t) => t._id === e) && !b.value.some((t) => t._id === e));
			if (!n.length) return;
			let r = (await Promise.all(n.map((e) => p.fetchQuery(T(e))))).filter((e) => !b.value.some((t) => t._id === e._id));
			r.length > 0 && (b.value = [...b.value, ...r]);
		}, { immediate: !0 });
		let C = (e, t) => {
			t(async () => {
				if (!e) {
					y.value = null;
					return;
				}
				let { list: t } = await p.fetchQuery(w(e));
				y.value = t;
			});
		};
		return (t, s) => (o(), n(c(e), a({
			modelValue: i.value,
			"onUpdate:modelValue": s[0] ||= (e) => i.value = e,
			"data-qa-bf-dropdown": "",
			options: S.value,
			label: c(f)("components.bfJob"),
			"option-value": "_id",
			"option-label": "displayName",
			"emit-value": "",
			"map-options": "",
			dense: "",
			flat: "",
			outlined: "",
			"dropdown-icon": "expand_more"
		}, t.$attrs, {
			"use-input": "",
			"input-debounce": c(d),
			multiple: r.multiple,
			loading: c(v),
			onFilter: C
		}), null, 16, [
			"modelValue",
			"options",
			"label",
			"input-debounce",
			"multiple",
			"loading"
		]));
	}
});
//#endregion
export { E as BfJobSelector, _ as JobGroupModelName, v as JobService, S as getJob, x as getJobs };

//# sourceMappingURL=index.es.js.map